<template>
    <div class="cmp-wrapper">
      <basic-container>
        <el-form
          ref="cashForm"
          :model="formData"
          :rules="rules"
          label-width="140px"
          label-position="left"
          size="mini"
        >
          <el-form-item label="营业执照类型" prop="businessLicenseType">
            <el-select v-model="formData.businessLicenseType" :disabled="true" placeholder="请选择">
            <el-option label="企业" value="1"></el-option>
            <el-option label="个体工商户" value="2"></el-option>
          </el-select>
          </el-form-item>

          <el-form-item label="开户类型" prop="isPublic">
            <el-select v-model="formData.isPublic" :disabled="disabledIsPublic" placeholder="请选择">
              <el-option label="私人银行卡" value="0"></el-option>
              <el-option label="对公账户" value="1" ></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item v-show="formData.isPublic==='1'" label="公司名称" prop="corpName">
            <el-input v-model.trim="formData.corpName" :disabled="disabledIsPublic" placeholder="请输入公司名称"></el-input>
          </el-form-item>

          <el-form-item v-show="formData.isPublic==='1'" label="公司证件类型" prop="idCardType">
            <el-select v-model="formData.idCardType" :disabled="disabledIsPublic" placeholder="请选择">
              <el-option label="统一社会信用代码" value="73" selected="true"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item v-show="formData.isPublic==='1'" label="营业执照编号" prop="idCardNo">
            <el-input v-model.trim="formData.idCardNo" :disabled="disabledIsPublic" placeholder="请输入"></el-input>
          </el-form-item>

          <el-form-item v-show="formData.isPublic==='0'" label="法人姓名" prop="legalPersonName">
            <el-input v-model.trim="formData.legalPersonName" placeholder="请输入"></el-input>
          </el-form-item>

          <el-form-item v-show="formData.isPublic==='0'" label="证件号" prop="legalPersonCardNo">
            <el-input v-model.trim="formData.legalPersonCardNo" placeholder="请输入"></el-input>
          </el-form-item>

          <br/>
          <h2 class="title">银行卡信息</h2>
 
          <el-form-item label="开户名称">
            <el-input v-model.trim="formData.cashAccountName" placeholder="请输入"></el-input>
          </el-form-item>

          <el-form-item label="认证方式" prop="authMethod">
            <el-select v-model="formData.authMethod" :disabled="disabledIsPublic || formData.isPublic==='1'" @change="handleAuthMethodChange" placeholder="请选择">
              <el-option label="银联鉴权" value="1" ></el-option>
              <el-option label="小额鉴权" value="2" ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="银行卡号" prop="cashAccountCode">
            <el-input v-model.trim="formData.cashAccountCode" placeholder="请输入"></el-input>
          </el-form-item>

          <el-form-item label="开户银行" prop="cashBankName">
            <el-select v-model="formData.cashBankName" @change="handleBankChange" filterable placeholder="请选择">
              <el-option v-for="item in banks" :key="item.ibps" :value="item.name" :label="item.cbsAbbr" ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="支行名称" prop="cashBankBranch">
            <el-select v-model="formData.cashBankBranch" filterable remote :remote-method="fetchFilteredBranches" @change="handleBranchChange" placeholder="请选择">
              <el-option v-for="item in filteredBranches" :key="item.bank_no" :value="item.bank_branch" :label="bank_branch" ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="支行联行号" prop="cashBankNo">
            <el-input v-model.trim="formData.cashBankNo" :disabled="true" placeholder="选择支行后自动填充"></el-input>
          </el-form-item>

          <el-form-item :label="showPhoneLabel" prop="cashMobile">
            <el-input v-model.trim="formData.cashMobile" placeholder="请输入"></el-input>
          </el-form-item>

          <el-form-item label="银行卡照片" prop="cardPic">
            <store-img-upload style="display:inline;" type="licensePic" @fileList="(data) => formData.cardPic= data[0]"/>
          </el-form-item>

          <el-form-item prop="agreed">
            <el-checkbox v-model="agreed" @change="handleAgreementChange">
              我已审慎阅读理解并同意
              <a href="https://my.orangebank.com.cn/orgLogin/hd/act//jianzb/jzbxym.html" target="_blank">《平安银行电子商务“见证宝”商户服务协议》、</a>
              <a href="https://auth.orangebank.com.cn/#/m/cDealOne" target="_blank">《平安数字用户服务协议》</a>
            </el-checkbox>
          </el-form-item>

        </el-form>
        <div class="footer">
          <el-button size="mini" @click="handleBack">取消</el-button>
          <el-button size="mini" type="primary" @click="onSubmit">提交认证</el-button>
          <el-button size="mini" type="primary" @click="reCheckBindCard">重新认证</el-button>
        </div>


        
        <div>
          <el-dialog
            title="验证绑卡"
            :visible.sync="showPersonalCheckCard"
            width="50%"
          >
            <h2>输入验证码</h2>
            <p>输入验证码后，正式签署合同</p>
            <p>已向法人手机号+86 {{formData.cashMobile}}发送验证码</p>
            <br/>
            <br/>
            <el-input v-model="bindCardCheck.code" placeholder="请输入验证码"></el-input>
            <div slot="footer" class="dialog-footer">
              <el-button @click="showPersonalCheckCard = false">取消</el-button>
              <el-button type="primary" @click="submitVerificationCode">确定</el-button>
            </div>
          </el-dialog>

        </div>

        <div>
          <el-dialog
            title="绑卡验证"
            :visible.sync="showPublicCheckCard"
            width="50%"
          >
            <h2>1.输入指令码</h2>
            <p>已向手机号+86 {{formData.cashMobile}}发送指令码</p>
            <p>请查收短信，指令吗48小时内有效</p>
            <p>如未收到，须等待24小时后重试</p>
            <br/>
            <br/>
            <el-input v-model="bindCardCheck.code" placeholder="请输入指令码"></el-input>
            <br/>
            <br/>
            <h2>2.输入银行卡到账金额</h2>
            <p>银行已向你想绑的银行卡转账，验证卡可正常收款。这是单独的转账！与贷款账单无关！</p>
            <P>请用银行app、或取银行柜台、或收款短信，查询余额。</P>
            <p>如未收到，须等待24小时后重新申请转账</p>
            <br/>
            <br/>
            <em>¥</em><el-input v-model="bindCardCheck.amount" placeholder="请输入银行卡到账金额"></el-input>
            <div slot="footer" class="dialog-footer">
              <el-button @click="showPublicCheckCard = false">取消</el-button>
              <el-button type="primary" @click="submitVerificationCode">确定</el-button>
            </div>
          </el-dialog>

        </div>



      </basic-container>
    </div>
  </template>
  
  <script>
  import { callbackify } from "util";
  export default {
    name: "subject-message",
    data() {

      var checkLicensePic=  (rules, val, callback)=> {
        const {cardPic}= this.formData
        if(!cardPic || cardPic === "") callback(new Error("请上传银行卡图片"))
        callback()
      }
  
      return {
        formData: {
          businessLicenseType: "",
          authMethod: "",
          subjectId: "",
          isPublic: "",
          cashAccountName: "",
          cashAccountCode: "",
          cashBankName: "",
          cashBankIbsp: "",
          cashBankNo: '',
          cashBankBranch: '',
          cashBankProvince: '',
          cashBankCity: '',
          cashMobile: '',
          cardPic: '',
          legalPersonName:'',
          legalPersonCardNo:'',
          corpName: ''

        },
        subjectDetail: {},
        bindCardCheck:{
          id: null,
          subjectId: "",
          amount: "",
          code: ""
        },
        subjectId: "",
        banks: [],       
        filteredBranches:[],
        selectBankAbbr: "",
        selectedBranch: "",
        showPublicCheckCard: false,
        showPersonalCheckCard: false,
        disabledIsPublic:false,
        agreed: false,
        rules: {
          cashAccountCode: [
            {
              required: true,
              message: "请输入银行卡号"
            }
          ],
          cashBankName: [
            {
              required: true,
              message: "请选择开户银行"
            }
          ],
          cashBankBranch: [
            {
              required: true,
              message: "请选择支行名称"
            }
          ],

          cashMobile: [
            {
              required: true,
              message: "请输入手机号"
            }
          ],
          
          cardPic: [{required: true, validator: checkLicensePic}],
        },
        
        pickerOptions: {
          disabledDate: (time) => {
            const now = new Date()
            const year = now.getFullYear()
            const month = now.getMonth()
            const day = now.getDate()-1
            return time.getTime() < new Date(year, month, day, 23, 59, 59).getTime()
          }
        },
      };
    },
    watch: {
    'formData.isPublic': {
      immediate: true,
      handler(val) {
        if(val==="1") {
          this.formData.authMethod="2";
          this.formData.cashAccountName=this.subjectDetail.corpName;
        } else if(val==="0"){
          this.formData.cashAccountName=this.subjectDetail.legalPersonName;
        }
      }
    },

    "formData.businessLicenseType": {
      immediate: true,
      handler(val) {
        if(val==="2") {
          this.disabledIsPublic=false;
        } else if(val ==="1"){
          this.formData.isPublic="1";
          this.formData.authMethod="2";
          this.formData.corpName=this.subjectDetail.corpName;
          this.formData.idCardType="73";
          this.formData.idCardNo=this.subjectDetail.uniformSocialCreditCode;
        }
      }
    },
    "formData.authMethod": {
      immediate: true,
      handler(val) {
        this.getBanks();
      }
    }
  },
    computed: {
      showPhoneLabel() {
        return this.formData.isPublic==='1' ? "联系手机号" : "预留手机号";
      }
    },
    created() {
      this.formData.subjectId = this.$route.query.subjectId
      this.bindCardCheck.subjectId=this.$route.query.subjectId
      this.initData();
    },
    beforeRouteEnter(to, from, next) {
      next(async vm => {
        try {
          vm.formData.subjectId = vm.$route.query.subjectId
          vm.bindCardCheck.subjectId=vm.$route.query.subjectId
          vm.initData();
        } catch (error) {
          console.log(error);
          next();
        }
        
      })
    },
    beforeRouteLeave(to, from, next) {
      this.formData.subjectId="";
      this.bindCardCheck.subjectId="";
      this.$refs.cashForm.resetFields(); 
      this.$destroy();
      next();
    },
    methods: {
      handleBack() {
        this.$refs["cashForm"].resetFields();
        this.$router.go(-1);
      },

      // handleAuthMethodChange(value){
      //   this.getBanks();
      // },

      handleBankChange(value){
        const selectedBank = this.banks.find(option => option.name===value);
        this.formData.cashBankIbsp=selectedBank.ibps;
        this.selectBankAbbr=selectedBank.cbsAbbr;
        this.fetchFilteredBranches();
      },

      handleBranchChange(value) {
        // 处理选择分行后的操作
        const selectedOption = this.filteredBranches.find(option => option.bank_branch === value);
        this.formData.cashBankNo=selectedOption.bank_no;
        this.formData.cashBankProvince=selectedOption.province;
        this.formData.cashBankCity=selectedOption.city;
        console.log('Selected branch:', value);
      },
      handleAgreementChange(){
        console.log(this.agreed);
      },

      async fetchFilteredBranches(query) {
        const{
          data
        } = await _api.splitAcc.getBranches({
          bankName: this.selectBankAbbr,
          searchBranch: query
        });
        if(data) {
          this.filteredBranches = data || [];
        }
      },

      async getBanks(){
        console.log(formData.authMethod);
        if(!formData.authMethod || formData.authMethod===""){
          return;
        }
        try {
          const{
            data
          } = await _api.splitAcc.getBankList({
            authMethod:this.formData.authMethod
          });
          if(data){
            this.banks=data||[];
          }
        } catch (error) {
          console.log(error);
        }
      },

      async initData() {
        const {ret, data} = await _api.splitAcc.getSubjectDetail({
          id: this.$route.query.subjectId
        });
        if (ret && data) {
          this.subjectDetail=data;
          this.formData.businessLicenseType=data.licenseType.toString();
          if(data.licenseType===1){
            this.disabledIsPublic=true;
            this.formData.isPublic="1";
            this.formData.cashAccountName=data.corpName;
            this.formData.authMethod="2";
            this.getBanks();
          } else if(data.licenseType===2){
            this.formData.cashAccountName=data.legalPersonName;
          }
          this.formData.idCardType="73";
          this.formData.idCardNo=data.uniformSocialCreditCode;
          this.formData.corpName=data.corpName;
          this.formData.legalPersonCardNo=data.legalPersonIdCardNo;
          this.formData.legalPersonName=data.legalPersonName;
        }
    },

      onSubmit() {
        //console.log(this.formData);
        if(!this.agreed) {
          this.$message({
            type: "warning",
            message: "请同意协议"
          });
          return;
        }
        this.$refs["cashForm"].validate(val => {
          if (val) {
            this.save();
          } else {
            this.$message({
              type: "warning",
              message: "请完成信息后提交"
            });
          }
        });
      },
      async save() {
        const {
          data: { id }
        } = await _api.splitAcc.bindCard(this.formData);
        if (id) {
          this.bindCardCheck.id = id;
          if(this.formData.authMethod==='1') {//银联鉴权
            this.showPersonalCheckCard=true;
          } else if(this.formData.authMethod==='2'){//小额鉴权
            this.showPublicCheckCard=true;
          }
          
        }
      },
      async getBanks(){
        const {
          data
        } = await _api.splitAcc.getBankList({
          authMethod: this.formData.authMethod
        });
        if(data) {
          this.banks = data || [];
        }
      },

      async submitVerificationCode(){
          const{
            ret
          } = await _api.splitAcc.bindAccountCardCheck(this.bindCardCheck);

          if(ret) {
            this.$message({
              message: '绑定成功',
              type: 'success'
            })
            this.showPersonalCheckCard=false;
            this.showPublicCheckCard=false;
            this.handleBack();
          }

      },

      reCheckBindCard(){
        if(this.formData.authMethod==='1') {//银联鉴权
          this.showPersonalCheckCard=true;
        } else if(this.formData.authMethod==='2'){//小额鉴权
          this.showPublicCheckCard=true;
        }
      }

    }
  };
  </script>
  <style scoped>
  .el-input {
    width: 300px;
  }
  .el-textarea {
    width: 400px;
  }
  .el-select {
    width: 130px;
  }
  .title {
    font-weight: 900;
    font-size: 18px;
  }
  a {
    color: #007bff; 
  }
  </style>
  